import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Nama', value: 'merchant_name' },
  { text: 'MID', value: 'mid' },
  { text: 'Type', value: 'merchant_type' },
  { text: 'Alamat Lengkap', value: 'address' },
  { text: 'Nomor Pengajuan', value: 'reference_number'},
  { text: 'Request Date', value: 'created_at' },
  { text: 'Last Update', value: 'last_updated' },
  { text: 'Jenis Pengajuan', value: 'task_type' },
  { text: 'Status', value: 'status' },
  { text: 'Action', value: 'action', width: '10' },
]);

export const search = {
  merchant_name: '',
  mid: '',
  merchant_type: '',
  task_type: '',
  address: '',
  reference_number: '',
  created_at: null,
  last_updated: null,
};
